import React, { useRef } from "react"
import PassUtils from "../data/PassUtils"
import TextInput, { ITextInput } from "../gui/TextInput/TextInput"
import IconButton from "../gui/Button/IconButton"
import DeleteIcon from "../gui/Icons/DeleteIcon"

export interface IPropertyRowProps {
    passwordId:string
    index:number
    name?:string
    value?:string
    onUpdate?:(index:number,key:string,val:string) => void
    onDelete?:() => void
}
export interface IPropertyRowRefProps {
    name:string
    value:string
    focus:(type:"name"|"val") => void
}

export default function PropertyRowEdit(props:IPropertyRowProps) {
    const {passwordId,index} = props
    const name = useRef<ITextInput|null>(null)
    const value = useRef<ITextInput|null>(null)
    const onDelete = () => props.onDelete?.()
    const onChange = (e:React.FocusEvent<HTMLInputElement>) => {
        if (!name.current || !value.current) return
        props.onUpdate?.(props.index, name.current.value!, value.current.value!)
    }
    return <div className="property flex top gap-8">
        <TextInput className="flex1" defaultValue={props.name} ref={name} onBlur={onChange} id={PassUtils.toInputId("name", passwordId, index)}/>
        <TextInput className="flex1" defaultValue={props.value} ref={value} onBlur={onChange} id={PassUtils.toInputId("val", passwordId, index)}/>
        {props.onDelete ? <IconButton onClick={onDelete}><DeleteIcon/></IconButton> : <div/>}
    </div>
}